import { render, staticRenderFns } from "./rooms.vue?vue&type=template&id=09428225"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"
import style0 from "./rooms.vue?vue&type=style&index=0&id=09428225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports